module.exports = __webpack_public_path__ + "img/custom6.d3252f5f.png";